
import { ParticipantFieldType } from '__generated__/graphql';
import AuLicenseConfigForm from './AuLicenseConfigForm';
import KnwuLicenseConfigForm from './KnwuLicenseConfigForm';
import ParticipantFieldConfigFormProps from './ParticipantFieldConfigFormProps';
import TimeConfigForm from './TimeConfigForm';

const configForms = {
  [ParticipantFieldType.au_license]: AuLicenseConfigForm,
  [ParticipantFieldType.knwu_license]: KnwuLicenseConfigForm,
  [ParticipantFieldType.time]: TimeConfigForm,
};

export const hasConfigForm = (type: ParticipantFieldType) => (
  type in configForms
);

const ParticipantFieldConfigForm = (options: ParticipantFieldConfigFormProps) => {
  if (!hasConfigForm(options.type)) {
    return <></>;
  }

  return (configForms as any)[options.type](options);
};

export default ParticipantFieldConfigForm;
